import { createSelector } from '@reduxjs/toolkit';
import { AppDomain } from '@ibk/shared-types';
const selectApplicationState = (state) => state.application;
export const selectAppDomain = createSelector([selectApplicationState], applicationState => applicationState.appDomain);
export const selectIsEmpresaDomain = createSelector([selectAppDomain], appDomain => appDomain === AppDomain.EMPRESA);
export const selectIsEscritorioDomain = createSelector([selectAppDomain], appDomain => appDomain === AppDomain.ESCRITORIO);
